import {FilterValuesType} from '../actions/actionTypes';

const defaultState = {
  isSet: false,
  channelCode: [],
  partnerBrandCode: [],
  partnerStoreCode: [],
  city: [],
  partnerPhyStoreCode: [],
  countryCode: [],
};
const commonFiltersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FilterValuesType.SET_COMMON_FILTERS:
      return {
        ...state,
        ...action.data,
        isSet: true,
      };

    default:
      return state;
  }
};

export default commonFiltersReducer;
